<template>
  <div id="data-list-list-view" class="data-list-container">
    <vx-card ref="listCard" :title="$t('Decarbonization.EnergyScenarios.Title')" title-color="black" refresh-content-action @refresh="refreshList"> 
      <vs-table
            ref="table"
            v-model="selected"
            pagination
            :max-items="itemsPerPage"
            search
            :data="energyScenarios"            
          >
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <vs-row vs-type="flex" vs-justify="space-between">
            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="4">
              <vs-button
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-add"
                @click="addNewData"
              >{{$t('AddNew')}}</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
              <Pager
                :currentPage="currentPage"
                :itemsPerPage="itemsPerPage"
                :totalCount="energyScenarios.length"
                :queriedItems="queriedItems"
                :pageSizes="[10,20,50]"
                @pageChanged="onPageChanged"
              ></Pager>
            </vs-col>
          </vs-row>
        </div>
        <template slot="thead">
          <vs-th>{{$t('Action')}}</vs-th>
          <vs-th sort-key="name">{{$t('Decarbonization.EnergyScenarios.Name')}}</vs-th>
          <vs-th sort-key="compilation">{{$t('Decarbonization.EnergyScenarios.Compilation')}}</vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td width="100px" class="whitespace-no-wrap">
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  @click.stop="editData(tr)"
                  v-b-tooltip.hover :title="$t('Edit')"
                />
                <feather-icon
                  icon="CopyIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  class="ml-2"
                  @click.stop="duplicateData(tr)"
                  v-b-tooltip.hover :title="$t('Duplicate')"
                />
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="openDeleteConfirm(tr.id)"
                  v-b-tooltip.hover :title="$t('Delete')"
                />
              </vs-td>
              <vs-td width="200px">
                <p class="font-medium truncate">{{ tr.name }}</p>
              </vs-td>
              <vs-td>
                <p class="font-medium truncate">{{ tr.compilation }}</p>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>
<script>

import { Pager } from "@/app/shared/components";

export default {
  components: {
    Pager
  },
  data() {
    return {
      selected: [],    
      itemsPerPage: 20,
      isMounted: false, 
      energyScenarios: []
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.energyScenarios.length;
    }
  },
  methods: {
    refreshList() {
      this.$cqrsGet("Cashflow/Decarbonization/EnergyScenarios/FindAll/")
        .then((response) => {
          const model = response.data.model;
          this.energyScenarios = model.map(x => ({
            id: x.id,
            name: x.name,
            compilation: x.compilation
          }));
        })
        .finally(() => {
          this.$refs.listCard.removeRefreshAnimation();
        });
    },
    onPageChanged(val) {
      this.itemsPerPage = val;
    },
    addNewData() {
      this.$router.push({ name: 'BSG-decarbonization-energyScenarios-edit', params: { editData: null} });
    },
    editData(model) {
      this.$router.push({ name: 'BSG-decarbonization-energyScenarios-edit', params: { editData: model } });
    },
    duplicateData(model) {
      const id = model.id;
      this.$cqrsPost('cashflow/decarbonization/energyScenarios/duplicate', { id })
        .then(() => {                
          this.$notifySaveSuccess();
          this.refreshList();
        })
    },
    openDeleteConfirm(id) {
      this.$deleteConfirmation({
        text: this.$t('Decarbonization.EnergyScenarios.ConfirmDelete'),
        accept:  () => this.deleteData(id)
      });
    },
    deleteData(id) {
      this.$vs.loading();
      this.$cqrsPost('cashflow/decarbonization/energyScenarios/delete', { id })
        .then(() => {
          this.$notifyDeleteSuccess(this.$t("Decarbonization.EnergyScenarios.DeletedConfirmation"));
        })
        .finally(() => {
          this.$vs.loading.close();
          this.$refs.listCard.refreshcard();
        });
    }
  },
  created() {
  },
  mounted() {
    if (!this.isMounted) {
      this.$refs.listCard.refreshcard();
    }
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
#data-list-list-view {
.vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 0.8rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 8px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--tbody-table {
      min-width: 200px;
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>